import React, { Fragment, useState, useEffect, useRef } from 'react'
import { IdleTimerProvider } from 'react-idle-timer/dist/index.legacy.esm.js'
import PropTypes from 'prop-types';

function LockScreen(props) {
    const [isLocked, setLock] = useState(false);
    const init = useRef(0);

    const handleOnIdle = () => {
      if (!isLocked) {
        setLock(true);
      }
    };

    const handleOnActive = () => {
      if (isLocked) {
        setLock(false);
      }
    };

    useEffect(() => {
      if (!init.current) {
        init.current = 1;
        return;
      }
      isLocked ? props.onScreenLocked() : props.onScreenUnlocked();
    }, [isLocked]);

    const renderLockScreenUi = () => {
    //   if (isLocked) {
    //     return (
    //       <div className="lock-screen-ui">
    //         <h2>Screen is Locked</h2>
    //         <p>Move the mouse or press a key to unlock.</p>
    //       </div>
    //     );
    //   }
    };

    const defaultLockScreenStyles = () => {
        return isLocked && !props.className
            ? {
                filter: 'blur(10px)',
                userSelect: 'none',
                height: '100vh',
                overflow: 'hidden'
            }
          : {
              height: '100vh'
            };
    }


    return (
      <Fragment>
        <IdleTimerProvider onIdle={handleOnIdle} onActive={handleOnActive} timeout={props.timeout} />
        <div
          style={defaultLockScreenStyles()}
          className={`react-lock-screen ${isLocked ? props.className : ''}`}
        >
          {props.children}
        </div>
        {renderLockScreenUi()}
      </Fragment>
    );
  }

  LockScreen.defaultProps = {
    onScreenLocked: () => {},
    onScreenUnlocked: () => {}
  };

LockScreen.propTypes = {
    timeout: PropTypes.number.isRequired,
    className: PropTypes.string,
    onScreenLocked: PropTypes.func,
    onScreenUnlocked: PropTypes.func
};

export default LockScreen;
